module.exports = __webpack_public_path__ + "img/lens-160-minus-02.96cf3b52.png";